var _defs, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWayTosuccessIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 339,
    viewBox: "0 0 98 339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 62.5px;\n        opacity: 0.36;\n        fill: #99449a;\n        font-family: Poppins;\n        font-weight: 500;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Loyalty",
    className: "cls-1",
    transform: "translate(72.18 346.102) rotate(-90) scale(1.558)"
  }, "Loyalty")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayTosuccessIcon2);
export default __webpack_public_path__ + "static/media/wayTosuccessIcon2.2af5554348578f65ba3a1ac2f61aaa1e.svg";
export { ForwardRef as ReactComponent };